import BgCloseUp from './BgCloseUp';
import BgFade from './BgFade';
import BgFadeBack from './BgFadeBack';
import BgFake3D from './BgFake3D';
import BgPan from './BgPan';
import BgParallax from './BgParallax';
import BgPullBack from './BgPullBack';
import BgReveal from './BgReveal';
import BgRotate from './BgRotate';
import BgSkew from './BgSkew';
import BgZoom from './BgZoom';
import ImageParallax from './ImageParallax';
export const backgroundScrollAnimations = {
  BgCloseUp,
  BgFade,
  BgFadeBack,
  BgFake3D,
  BgPan,
  BgParallax,
  BgPullBack,
  BgReveal,
  BgRotate,
  BgSkew,
  BgZoom,
  ImageParallax
};
//# sourceMappingURL=index.js.map